import React, { useEffect, useState, useRef } from 'react';
import { Button, message, Row, Col, Tooltip } from 'kenshin';
import TablePro from '@/components/TablePro';
import { useSelector, useDispatch } from 'umi';
import ModalFormPro from '@/components/ModalFormPro';
import TreeData from '@/pages/project/taskManage/components/TreeData';
import { findTree } from '@/components/ServCategoryList';
import EllipsisTooltip from '@/components/EllipsisTooltip';
import { timerYMD } from '@/_util/componentsUtil';
import {
  getCloumns,
  getSearchCloumns,
} from '@/pages/project/taskManage/cloumnsData';

const RelateTaskModal = ({ visible, onCancel, onOk }) => {
  // 菜单操作
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editModalData, setEditModalData] = useState(null);
  const [employeeAll, setEmployeeAll] = useState([]);
  const [leaderKey, setLeaderKey] = useState('');

  const [selectKey, setSelectKey] = useState([]);
  const [selectRows, setSelectRows] = useState([]);

  /** 修改状态 */
  const [statusVisible, setStatusVisible] = useState(false);
  const [statusData, setStatusData] = useState([]);

  const [btnDisabled, setBtnDisabled] = useState(false);

  const projectId = useRef();

  const tableRef = useRef(null);
  const curData = useRef(null); // 存储当前服务类目对应的数据

  const searchCloumns = getSearchCloumns({ employeeAll });

  const project = useSelector(({ project }) => project);
  const dispatch = useDispatch();

  const columns = getCloumns({
    employeeAll,
    setStatusVisible,
    setStatusData,
    showOptions: false,
  });

  useEffect(() => {
    dispatch({
      type: 'project/getSimpProjectList',
    });
    // 组织架构
    dispatch({
      type: 'systemOrgani/getAllEmployee',
    }).then((res) => {
      setEmployeeAll(res);
    });
    // 服务类目
    // dispatch({
    //   type: 'project/getServcatgEasyList',
    // });
    return () => {
      dispatch({
        type: 'project/save',
        payload: {
          taskList: {},
          taskListSearchForm: {},
        },
      });
    };
  }, []);

  const treeHandleChange = (keys, row) => {
    curData.current = row;
    projectId.current = row.projectId;
    tableRef.current?.reload(
      {
        projectId: row.projectId,
        proServCatgId: row.proServCatgId,
      },
      true,
    );
  };

  const handleOk = () => {
    // console.log("selectKey",selectKey);
    onOk?.(selectRows);
  };

  const onSubmit = (payload) => {
    payload.projectId = projectId.current;
    if (employeeAll?.length == 0) {
      return false;
    }
    if (payload.taskTime) {
      const [start, end] = payload.taskTime;
      payload.taskBeginTime = moment(start)
        .startOf('d')
        .format('YYYY-MM-DD HH:mm:ss');
      payload.taskEndTime = moment(end)
        .endOf('d')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    payload.taskTime = undefined;
    if (payload.memberList) {
      payload.memberList = payload.memberList.map((item) => item.split('-')[1]);
    }
  };

  const rowSelection = {
    selectedRowKeys: selectKey,
    onChange: (userIdList, rows) => {
      setSelectKey(userIdList);
      setSelectRows(rows);
    },
    // getCheckboxProps: (record) => ({
    //   disabled: record.taskStatus == 1, // Column configuration not to be checked
    // }),
  };

  return (
    <ModalFormPro
      title="关联旧任务"
      visible={visible}
      onCancel={onCancel}
      onSave={handleOk}
      width={1200}
      destroyOnClose
      edtaFormItem={[
        {
          full: true,
          render() {
            return (
              <Row gutter="20" style={{ height: '100%' }}>
                <Col span={4}>
                  <TreeData onChange={treeHandleChange} />
                </Col>
                <Col span={16}>
                  <TablePro
                    params={{
                      projectId: projectId.current,
                      proServCatgId: curData.current?.proServCatgId,
                    }}
                    request="project/gettorelataskplanpageexcel"
                    rowKey="taskId"
                    searchCloumns={searchCloumns}
                    columns={columns}
                    scrollX
                    curColumns
                    columnsOptions={false}
                    actionRef={(ref) => (tableRef.current = ref)}
                    onSubmit={onSubmit}
                    data={project.excelTaskList}
                    childrenColumnName="child"
                    rowSelection={{
                      type: 'checkbox',
                      ...rowSelection,
                    }}
                  />
                </Col>
              </Row>
            );
          },
        },
      ]}
    />
  );
};

export default RelateTaskModal;
